/* Pjotr3DShop theme — lightweight interactions (no framework) */
(function () {
  'use strict';

  var money = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR';
  // shop.money_format from theme.liquid, e.g. "€{{amount_with_comma_separator}}".
  // Every JS-rendered price (variant change, savings line, bundle total) used
  // Intl with the page language, which printed "€16.99" on English pages
  // where every Liquid `| money` says "€16,99". Same format string as Liquid.
  var moneyFormat = typeof window.themeMoneyFormat === 'string' ? window.themeMoneyFormat : '';

  function formatMoney(cents) {
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (m) {
      var key = m[1];
      var decimals = key.indexOf('no_decimals') === -1 ? 2 : 0;
      var thousands = ',', decimal = '.';
      if (key.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
      else if (key.indexOf('apostrophe_separator') !== -1) { thousands = "'"; }
      else if (key.indexOf('period_and_space_separator') !== -1) { thousands = ' '; }
      else if (key.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }
      var parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
      var sign = parts[0].charAt(0) === '-' ? '-' : '';
      var whole = parts[0].replace(/^-/, '').replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return sign + moneyFormat.replace(m[0], whole + (decimals ? decimal + parts[1] : ''));
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: money
      }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-open]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    var close = menu.querySelector('[data-menu-close]');
    var panel = menu.querySelector('.mobile-menu__panel');
    function focusables() {
      return panel ? panel.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])') : [];
    }
    function open() {
      menu.classList.add('is-open'); document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      var f = focusables();
      if (f.length) f[0].focus();
    }
    function shut() {
      menu.classList.remove('is-open'); document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('click', function (e) { if (e.target === menu) shut(); });
    // Close the drawer when a navigation link is tapped.
    if (panel) panel.addEventListener('click', function (e) { if (e.target.closest('a')) shut(); });
    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { shut(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Desktop nav dropdowns (aria-expanded state) ---------- */
  function initNavDropdowns() {
    document.querySelectorAll('[data-dropdown]').forEach(function (item) {
      var toggle = item.querySelector('[data-dropdown-toggle]');
      if (!toggle) return;
      function set(open) { toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { set(true); });
      item.addEventListener('mouseleave', function () { set(false); });
      item.addEventListener('focusin', function () { set(true); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); if (toggle.blur) toggle.blur(); } });
    });
  }

  /* ---------- Cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var changed = el.textContent !== String(count);
      el.textContent = count;
      el.hidden = count === 0;
      if (changed && count > 0) {
        el.classList.remove('is-bumped');
        void el.offsetWidth; /* restart the pop */
        el.classList.add('is-bumped');
      }
    });
    updateFaviconCount(count);
  }
  /* Locale-aware URL join: window.routes.root is '/' on the primary locale
     and '/nl' (or '/nl/') on others — strip any trailing slash before joining
     so both forms produce '/nl/cart.js', never '/nl//cart.js'. */
  var routes = window.routes || {};
  function routeUrl(path) { return ((routes.root || '/').replace(/\/+$/, '')) + path; }
  function refreshCartCount() {
    fetch(routeUrl('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- Favicon cart count ---------- */
  /* Draws the cart quantity onto the browser-tab icon (badge-style disc,
     bottom-right). The CDN favicon must load with CORS or the canvas
     taints — on any failure the original icon is left untouched. */
  var faviconCount = {
    enabled: document.body.getAttribute('data-favicon-count') === 'true',
    link: null, base: null, original: '', last: -1
  };
  function drawFaviconCount() {
    var count = faviconCount.last;
    if (count === 0) { faviconCount.link.href = faviconCount.original; return; }
    var size = 64;
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    var ctx = canvas.getContext('2d');
    if (!ctx) { faviconCount.enabled = false; return; }
    ctx.drawImage(faviconCount.base, 0, 0, size, size);
    var r = 19, cx = size - r - 1, cy = size - r - 1;
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = '#FD8700';
    ctx.fill();
    ctx.fillStyle = '#1A1A1A';
    ctx.font = '700 ' + (count > 9 ? '22' : '28') + 'px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(count > 9 ? '9+' : String(count), cx, cy + 1);
    try { faviconCount.link.href = canvas.toDataURL('image/png'); }
    catch (e) { faviconCount.enabled = false; faviconCount.link.href = faviconCount.original; }
  }
  function updateFaviconCount(count) {
    if (!faviconCount.enabled || count === faviconCount.last) return;
    if (!faviconCount.link) {
      faviconCount.link = document.querySelector('link[rel="icon"]');
      if (!faviconCount.link) { faviconCount.enabled = false; return; }
      faviconCount.original = faviconCount.link.href;
    }
    faviconCount.last = count;
    if (faviconCount.base) { drawFaviconCount(); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { faviconCount.base = img; drawFaviconCount(); };
    img.onerror = function () { faviconCount.enabled = false; };
    img.src = faviconCount.original;
  }
  function initFaviconCount() {
    var el = document.querySelector('[data-cart-count]');
    updateFaviconCount(el ? (parseInt(el.textContent, 10) || 0) : 0);
  }

  var cartDrawerEnabled = document.body.getAttribute('data-cart-drawer-enabled') === 'true';
  // Sitewide discount display (Theme settings → Sale display). Mirrors the Liquid math:
  // integer cents, truncating division, so JS and server render identical prices.
  var sitewidePct = parseInt(document.body.getAttribute('data-discount-pct'), 10) || 0;
  // Per-product override: roots carry data-sale-pct (snippets/sale-pct.liquid), 0 for excluded brands.
  function salePctFor(el) {
    var host = el && el.closest ? el.closest('[data-sale-pct]') : null;
    if (!host) return sitewidePct;
    var n = parseInt(host.getAttribute('data-sale-pct'), 10);
    return isNaN(n) ? sitewidePct : n;
  }
  function discounted(cents, pct) {
    if (pct === undefined) pct = sitewidePct;
    // +49 = price minus the discount rounded half-up to the cent, as Shopify's checkout does.
    return pct > 0 ? Math.floor((cents * (100 - pct) + 49) / 100) : cents;
  }
  function priceBase(v) { return v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price; }

  /* ---------- Add to cart (AJAX) ---------- */
  function initProductForm() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        var original = btn ? btn.innerHTML : '';
        var labelAdding = btn ? (btn.dataset.labelAdding || 'Adding…') : 'Adding…';
        var labelAdded = btn ? (btn.dataset.labelAdded || '✓ Added to cart') : '✓ Added to cart';
        if (btn) { btn.disabled = true; btn.innerHTML = labelAdding; }
        var payload = serialize(form);
        if (cartDrawerEnabled) { payload.sections = 'cart-drawer'; }
        fetch(routeUrl('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || 'Could not add to cart');
            if (cartDrawerEnabled && res.d.sections && window.__renderCartDrawer) {
              window.__renderCartDrawer(res.d.sections['cart-drawer']);
            }
            refreshCartCount();
            if (btn) { btn.innerHTML = labelAdded; btn.classList.add('is-added'); setTimeout(function () { btn.disabled = false; btn.innerHTML = original; btn.classList.remove('is-added'); }, 1600); }
            if (window.__closeQuickView) window.__closeQuickView();
            afterAddToCart();
          }).catch(function (err) {
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
            var note = form.querySelector('[data-form-error]');
            if (note) { note.textContent = err.message; note.hidden = false; }
          });
      });
    });
  }

  function serialize(form) {
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var payload = { id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 };
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (f) {
      if ((f.type === 'checkbox' || f.type === 'radio') && !f.checked) return;
      if (f.disabled) return; // hidden kit fields (e.g. colours on a single-colour variant)
      var key = f.name.replace('properties[', '').replace(']', '');
      if (f.value) props[key] = f.value;
    });
    if (Object.keys(props).length) payload.properties = props;
    return payload;
  }

  function openCartDrawerOrGo() {
    // Fallback when the drawer is disabled: bump the header cart icon.
    var icon = document.querySelector('[data-cart-icon]');
    if (icon) { icon.classList.add('pulse'); setTimeout(function () { icon.classList.remove('pulse'); }, 600); }
  }

  /* After a successful AJAX add — Theme settings → Cart → "After add to cart".
     drawer (default) opens the cart drawer, stay just pulses the header icon
     (the buttons flash their own Added label), checkout goes straight there. */
  var atcAction = document.body.getAttribute('data-atc-action') || 'drawer';
  function afterAddToCart() {
    if (atcAction === 'checkout') { window.location.href = routeUrl('/checkout'); return; }
    if (atcAction !== 'stay' && cartDrawerEnabled && window.__openCartDrawer) { window.__openCartDrawer(); return; }
    openCartDrawerOrGo();
  }

  /* ---------- Cookie consent ---------- */
  function initCookieBanner() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var KEY = 'cookie-consent';
    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function apply(granted) {
      try { localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch (e) {}
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, function () {});
        }
      } catch (e) {}
      banner.hidden = true;
    }
    if (stored()) { banner.hidden = true; return; }
    // Respect Shopify's region logic when available (don't show where not required).
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.shouldShowGDPRBanner && !Shopify.customerPrivacy.shouldShowGDPRBanner()) {
        banner.hidden = true; return;
      }
    } catch (e) {}
    // Shopify's own consent banner (Admin → Customer privacy) mounts async as
    // #shopify-pc__banner. When it owns consent this one stays hidden — two
    // banners at once, and the visitor's answer here couldn't silence it anyway.
    function nativeBanner() { return document.getElementById('shopify-pc__banner'); }
    function decidedElsewhere() {
      try {
        var c = Shopify.customerPrivacy.currentVisitorConsent();
        return !!(c && (c.analytics || c.marketing || c.preferences));
      } catch (e) { return false; }
    }
    var observer = new MutationObserver(function () {
      if (nativeBanner()) { banner.hidden = true; observer.disconnect(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      if (nativeBanner() || decidedElsewhere()) { banner.hidden = true; return; }
      banner.hidden = false;
    }, 1500);
    var accept = banner.querySelector('[data-cookie-accept]');
    var decline = banner.querySelector('[data-cookie-decline]');
    if (accept) accept.addEventListener('click', function () { apply(true); });
    if (decline) decline.addEventListener('click', function () { apply(false); });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    function toggle() { btn.classList.toggle('is-visible', window.pageYOffset > 600); }
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    toggle();
  }

  /* ---------- Dismissible announcement bar ---------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var key = 'ann:' + (bar.getAttribute('data-announcement-key') || '');
    try { if (localStorage.getItem(key) === '1') { bar.hidden = true; return; } } catch (e) {}
    var close = bar.querySelector('[data-announcement-close]');
    if (close) close.addEventListener('click', function () {
      try { localStorage.setItem(key, '1'); } catch (e) {}
      // Fold the bar shut; hide for real once the transition lands.
      bar.style.height = bar.offsetHeight + 'px';
      void bar.offsetHeight;
      bar.classList.add('is-dismissing');
      var done = false;
      function finish() { if (done) return; done = true; bar.hidden = true; }
      bar.addEventListener('transitionend', finish);
      setTimeout(finish, 350);
    });
  }

  /* ---------- Header shadow on scroll ---------- */
  function initHeaderShadow() {
    var header = document.querySelector('.site-header');
    if (!header || header.classList.contains('site-header--static')) return;
    function toggle() { header.classList.toggle('is-scrolled', window.pageYOffset > 4); }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var lastFocus = null;
    var debounce;

    function open() {
      lastFocus = document.activeElement;
      panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false');
      setTimeout(function () { input.focus(); }, 40);
    }
    function close() {
      panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-search-close]')) { close(); return; }
      if (panel.classList.contains('is-open') && !e.target.closest('[data-search-panel]') && !e.target.closest('[data-search-open]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    var seq = 0; // ignore out-of-order responses (slow query resolving after a newer one)
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { seq++; results.innerHTML = ''; results.classList.remove('is-active'); return; }
      debounce = setTimeout(function () {
        var mySeq = ++seq;
        results.classList.add('is-active');
        results.innerHTML = '<p class="psearch__loading">' + (results.dataset.loading || 'Searching…') + '</p>';
        var url = (routes.predictive_search || routeUrl('/search/suggest')) + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6';
        fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) { if (mySeq === seq) results.innerHTML = html; })
          .catch(function () { if (mySeq === seq) results.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------- Wishlist + recently viewed (localStorage) ---------- */
  function lsGet(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function lsSet(key, arr) { try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {} }
  function fetchCard(handle) { return fetch(routeUrl('/products/' + handle + '?section_id=card')).then(function (r) { return r.text(); }); }
  function appendCards(grid, handles, done, pruneKey) {
    // Placeholder slots keep the grid in list order even though fetches resolve out of order.
    handles.forEach(function (h) {
      var slot = document.createElement('div');
      grid.appendChild(slot);
      fetchCard(h).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var card = tmp.querySelector('.product-card');
        if (card) { slot.replaceWith(card); if (done) done(); refreshWishUI(); initCardSwatches(); }
        else {
          // No card in the response: the product was deleted — drop the stale handle.
          slot.remove();
          if (pruneKey) lsSet(pruneKey, lsGet(pruneKey).filter(function (x) { return x !== h; }));
        }
      }).catch(function () { slot.remove(); });
    });
  }

  function refreshWishUI() {
    var list = lsGet('wishlist');
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var w = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-wished', w);
      b.setAttribute('aria-pressed', w ? 'true' : 'false');
    });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = lsGet('wishlist');
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    appendCards(grid, list, null, 'wishlist');
  }

  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var h = btn.getAttribute('data-handle');
      var list = lsGet('wishlist');
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      lsSet('wishlist', list);
      refreshWishUI();
      if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
    });
    refreshWishUI();
    renderWishlistPage();
  }

  function initRecentlyViewed() {
    var KEY = 'recently-viewed';
    var root = document.querySelector('[data-product-handle]');
    var current = root ? root.getAttribute('data-product-handle') : null;
    var list = lsGet(KEY);
    if (current) {
      list = list.filter(function (h) { return h !== current; });
      list.unshift(current);
      list = list.slice(0, 8);
      lsSet(KEY, list);
    }
    var sec = document.querySelector('[data-recently-viewed]');
    if (!sec) return;
    var grid = sec.querySelector('[data-recently-grid]');
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    var show = lsGet(KEY).filter(function (h) { return h !== current; }).slice(0, limit);
    if (!show.length) return;
    appendCards(grid, show, function () { sec.hidden = false; }, KEY);
  }

  /* ---------- Quick view modal ---------- */
  function initQuickView() {
    var modal = document.querySelector('[data-quickview-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-quickview-body]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); modal.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); modal.setAttribute('inert', '');
      document.body.style.overflow = ''; body.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    window.__closeQuickView = function () { if (modal.classList.contains('is-open')) close(); };

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quickview-open]');
      if (trigger) {
        e.preventDefault();
        var h = trigger.getAttribute('data-handle');
        body.innerHTML = '<p class="quickview__loading">' + (body.dataset.loading || 'Loading…') + '</p>';
        open();
        fetch(routeUrl('/products/' + h + '?section_id=quick-view'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            body.innerHTML = html;
            initVariants(); initProductForm(); initQty();
            var cb = modal.querySelector('[data-quickview-close]'); if (cb) cb.focus();
          }).catch(function () { close(); });
        return;
      }
      if (e.target.closest('[data-quickview-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---------- Product-card colour swatches ---------- */
  function initCardSwatches() {
    document.querySelectorAll('[data-card-swatches]').forEach(function (box) {
      if (box.dataset.swbound) return;
      box.dataset.swbound = '1';
      var card = box.closest('.product-card');
      var img = card && card.querySelector('.product-card__media img');
      if (!img) return;
      var original = img.getAttribute('src');
      var originalSet = img.getAttribute('srcset');
      var activeSrc = null;
      // srcset wins over src, so a swap must override both.
      function show(src) {
        if (src) { img.src = src; img.srcset = src; }
        else { img.src = original; if (originalSet) img.srcset = originalSet; else img.removeAttribute('srcset'); }
      }
      box.querySelectorAll('.card-swatch').forEach(function (sw) {
        var src = sw.getAttribute('data-swatch-img');
        sw.addEventListener('mouseenter', function () { if (src) show(src); });
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          box.querySelectorAll('.card-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          activeSrc = src || null;
          if (card) card.classList.toggle('swatch-swapped', !!activeSrc);
          show(activeSrc);
        });
      });
      box.addEventListener('mouseleave', function () { show(activeSrc); });
    });
  }

  /* ---------- Quick add (from product cards) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = btn.dataset.labelAdding || 'Adding…';
      var payload = { id: id, quantity: 1 };
      if (cartDrawerEnabled) payload.sections = 'cart-drawer';
      fetch(routeUrl('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || 'Could not add to cart');
          if (cartDrawerEnabled && res.d.sections && window.__renderCartDrawer) window.__renderCartDrawer(res.d.sections['cart-drawer']);
          refreshCartCount();
          btn.innerHTML = btn.dataset.labelAdded || '✓ Added';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1500);
          afterAddToCart();
        }).catch(function () {
          btn.innerHTML = btn.dataset.labelError || 'Couldn’t add — try again';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2200);
        });
    });
  }

  /* ---------- Slide-out cart drawer ---------- */
  function initCartDrawer() {
    var section = document.getElementById('shopify-section-cart-drawer');
    if (!cartDrawerEnabled || !section) return;
    var lastFocus = null;

    function drawer() { return section.querySelector('[data-cart-drawer]'); }
    function isOpen() { var d = drawer(); return d && d.classList.contains('is-open'); }
    function focusables() {
      var d = drawer();
      return d ? d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])') : [];
    }
    function open() {
      var d = drawer(); if (!d) return;
      lastFocus = document.activeElement;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      var closeBtn = d.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      var d = drawer(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', '');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function render(html) {
      if (html == null) return;
      var wasOpen = isOpen();
      // innerHTML replacement resets the ship bar, so carry the old fill
      // width across and let the CSS transition play from there.
      var oldBar = section.querySelector('.ship-bar span');
      var oldW = oldBar ? parseFloat(oldBar.style.width) || 0 : null;
      section.innerHTML = html;
      if (wasOpen) {
        var d = drawer();
        if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert'); }
        document.body.style.overflow = 'hidden';
      }
      var bar = section.querySelector('.ship-bar span');
      if (bar && oldW !== null) {
        var newW = parseFloat(bar.style.width) || 0;
        if (newW !== oldW) {
          bar.style.transition = 'none';
          bar.style.width = oldW + '%';
          void bar.offsetWidth;
          bar.style.transition = '';
          bar.style.width = newW + '%';
          if (newW >= 100 && oldW < 100) {
            var ship = bar.closest('.cart-drawer__ship');
            if (ship) ship.classList.add('is-unlocked');
          }
        }
      }
    }
    window.__openCartDrawer = open;
    window.__renderCartDrawer = render;

    function change(line, qty) {
      fetch(routeUrl('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
      }).then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections['cart-drawer'] != null) render(cart.sections['cart-drawer']);
          updateCartCount(cart.item_count);
        }).catch(function () {});
    }

    // Delegated so handlers survive innerHTML re-renders.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
      var stepEl = e.target.closest('[data-cart-minus], [data-cart-plus], [data-cart-remove]');
      if (!stepEl) return;
      var itemEl = stepEl.closest('[data-line]');
      if (!itemEl) return;
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      var input = itemEl.querySelector('[data-cart-qty]');
      var cur = input ? (parseInt(input.value, 10) || 0) : 1;
      var next = stepEl.hasAttribute('data-cart-remove') ? 0 : (stepEl.hasAttribute('data-cart-minus') ? Math.max(0, cur - 1) : cur + 1);
      change(line, next);
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var itemEl = input.closest('[data-line]');
      if (itemEl) change(parseInt(itemEl.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-root]').forEach(function (root) {
      if (root.dataset.vbound) return;
      root.dataset.vbound = '1';
      var inModal = root.closest('[data-quickview-modal]');
      var rootPct = salePctFor(root);
      var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
      // inventory_policy isn't in the variant JSON; Liquid ships the pre-order ids separately.
      var preorderIds = (root.getAttribute('data-preorder-ids') || '').split(',').filter(Boolean);
      // Tracked variants that do not oversell: real shelf stock, so even own-brand items read "In stock".
      var shelfIds = (root.getAttribute('data-shelf-ids') || '').split(',').filter(Boolean);
      // inventory_quantity isn't in the variant JSON either: "id:qty," pairs from Liquid.
      var qtyById = {};
      (root.getAttribute('data-variant-qty') || '').split(',').filter(Boolean).forEach(function (pair) {
        var p = pair.split(':');
        qtyById[p[0]] = parseInt(p[1], 10) || 0;
      });
      function qtyOf(v) { return String(v.id) in qtyById ? qtyById[String(v.id)] : (v.inventory_quantity || 0); }
      // Ordered-in items (custom.lead_time): pre-order state renders as "Add to cart" + lead-time note.
      var leadTime = (root.getAttribute('data-lead-time') || '').trim();
      var statusWrap = root.querySelector('[data-stock-status-wrap]');
      var idField = root.querySelector('[name="id"]');
      var priceEls = Array.prototype.slice.call(root.querySelectorAll('[data-price-target]'));
      if (!inModal) {
        var stickyPrice = document.querySelector('[data-sticky-atc] [data-price-target]');
        if (stickyPrice) priceEls.push(stickyPrice);
      }
      var addBtn = root.querySelector('[data-add-to-cart]');
      var stickyBtn = inModal ? null : document.querySelector('[data-sticky-add]');
      var gallery = inModal ? null : document.querySelector('[data-gallery]');
      var savingsEl = root.querySelector('[data-savings]');
      var stockEl = root.querySelector('[data-stock]');
      var saleBadges = root.querySelectorAll('[data-sale-badge]');

      function currentOptions() {
        var opts = [];
        root.querySelectorAll('[data-option-index]').forEach(function (input) {
          if (input.type === 'radio') {
            var checked = root.querySelector('[name="' + input.name + '"]:checked');
            if (checked) opts[parseInt(checked.getAttribute('data-option-index'), 10)] = checked.value;
          } else {
            opts[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
          }
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      // Grey out option values whose combination has no available variant.
      function markAvailability() {
        var opts = currentOptions();
        root.querySelectorAll('input[data-option-index]').forEach(function (input) {
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          var candidate = opts.slice();
          candidate[idx] = input.value;
          var m = findVariant(candidate);
          var wrap = input.closest('.variant-pill, .swatch');
          if (wrap) wrap.classList.toggle('is-unavailable', !(m && m.available));
        });
      }

      function update() {
        var opts = currentOptions();
        var match = findVariant(opts);
        markAvailability();
        if (!match) return;
        if (idField) idField.value = match.id;
        priceEls.forEach(function (el) { el.innerHTML = renderPrice(match); });
        var isBackorder = match.available && preorderIds.indexOf(String(match.id)) > -1;
        var isLead = match.available && !!leadTime;
        var isPre = isBackorder && !leadTime;
        if (addBtn) {
          if (match.available) {
            addBtn.disabled = false;
            addBtn.textContent = isPre ? (addBtn.dataset.labelPreorder || 'Pre-order') : (addBtn.dataset.labelCart || 'Add to cart');
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.dataset.labelSoldout || 'Sold out';
          }
        }
        var preNote = root.querySelector('[data-preorder-note]');
        if (preNote) preNote.hidden = !isPre;
        var leadNote = root.querySelector('[data-lead-note]');
        if (leadNote) leadNote.hidden = !isLead;
        // Back-in-stock request: only for a sold-out variant; keep its hidden fields on the selected one.
        var notify = root.querySelector('[data-notify]');
        if (notify && !notify.querySelector('[data-notify-done]')) {
          notify.hidden = !!match.available;
          var nVar = notify.querySelector('[data-notify-variant]');
          if (nVar) nVar.value = variants.length > 1 ? match.title : '-';
          var nSku = notify.querySelector('[data-notify-sku]');
          if (nSku) nSku.value = match.sku || '';
          var nUrl = notify.querySelector('[data-notify-url]');
          if (nUrl) nUrl.value = (nUrl.dataset.baseUrl || '') + '?variant=' + match.id;
        }
        if (statusWrap) {
          var st = '';
          if (!match.available) st = 'soldout';
          else if (isLead) st = 'lead';
          else if (match.inventory_management) {
            var ownBrand = statusWrap.hasAttribute('data-own-brand');
            if (qtyOf(match) > 0 && (!ownBrand || shelfIds.indexOf(String(match.id)) > -1)) st = 'instock';
            else if (isPre && !ownBrand) st = 'preorder';
          }
          if (st) {
            var cls = 'stock-status stock-status--' + st;
            if (st === 'lead') cls += (parseInt(leadTime, 10) > 7) ? ' stock-status--lead-long' : ' stock-status--lead-short';
            var labelKey = 'label' + st.charAt(0).toUpperCase() + st.slice(1);
            statusWrap.innerHTML = '<span class="' + cls + '"><span class="stock-status__dot" aria-hidden="true"></span></span>';
            statusWrap.firstChild.appendChild(document.createTextNode(statusWrap.dataset[labelKey] || ''));
          } else {
            statusWrap.innerHTML = '';
          }
        }
        if (stickyBtn) {
          stickyBtn.disabled = !match.available;
          if (addBtn) stickyBtn.textContent = addBtn.textContent;
        }
        if (gallery && gallery._goToMedia && match.featured_media && match.featured_media.id) {
          gallery._goToMedia(match.featured_media.id);
        }
        var vBase = priceBase(match);
        var vFinal = discounted(match.price, rootPct);
        if (savingsEl) {
          if (vBase > vFinal) {
            var save = vBase - vFinal;
            var pct = Math.round(save * 100 / vBase);
            savingsEl.textContent = (savingsEl.dataset.label || 'Save') + ' ' + formatMoney(save) + ' (' + pct + '%)';
            savingsEl.hidden = false;
          } else { savingsEl.hidden = true; }
        }
        saleBadges.forEach(function (badge) {
          if (vBase > vFinal) {
            badge.textContent = '−' + Math.round((vBase - vFinal) * 100 / vBase) + '%';
            badge.hidden = false;
          } else { badge.hidden = true; }
        });
        if (stockEl) {
          var threshold = parseInt(stockEl.dataset.threshold, 10) || 0;
          var q = qtyOf(match);
          if (match.inventory_management && match.available && threshold > 0 && q > 0 && q <= threshold) {
            stockEl.innerHTML = '<span class="product-stock__dot"></span>' + (stockEl.dataset.only || 'Only') + ' ' + q + ' ' + (stockEl.dataset.left || 'left');
            stockEl.hidden = false;
          } else { stockEl.hidden = true; }
        }
        root.querySelectorAll('[data-selected-value]').forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-selected-value'), 10);
          el.textContent = opts[idx] || '';
        });
      }

      function renderPrice(v) {
        var base = priceBase(v);
        var final = discounted(v.price, rootPct);
        if (base > final) {
          return '<del>' + formatMoney(base) + '</del> <ins>' + formatMoney(final) + '</ins>';
        }
        return formatMoney(v.price);
      }

      root.addEventListener('change', update);
      markAvailability();
    });
  }

  /* ---------- Product recommendations (algorithmic) ---------- */
  function initProductRecommendations() {
    var c = document.querySelector('[data-product-recommendations]');
    if (!c) return;
    var url = c.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      // Only swap in the API result when it actually returned products.
      if (tmp.querySelector('.product-grid')) c.innerHTML = tmp.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Gallery lightbox (tap to zoom) ---------- */
  function initLightbox() {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    var track = lb.querySelector('[data-lightbox-track]');
    var slides = track.querySelectorAll('[data-lb-slide]');
    var counter = lb.querySelector('[data-lightbox-counter]');
    var galleryViewport = document.querySelector('[data-gallery-viewport]');
    var lastFocus = null;
    var zoomed = null;

    function setCounter(i) { if (counter) counter.textContent = (i + 1) + ' / ' + slides.length; }
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function goTo(i, smooth) { track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); setCounter(i); pauseVideos(); }
    function resetZoom() { if (zoomed) { zoomed.style.transform = ''; zoomed.classList.remove('is-zoomed'); zoomed = null; } }
    function pauseVideos() { track.querySelectorAll('video').forEach(function (v) { v.pause(); }); }
    function open(i) {
      lastFocus = document.activeElement;
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      goTo(i || 0, false);
      var c = lb.querySelector('[data-lightbox-close]'); if (c) c.focus();
    }
    function close() {
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ''; resetZoom(); pauseVideos();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    window.__openLightbox = open;

    if (galleryViewport) {
      galleryViewport.querySelectorAll('[data-slide]').forEach(function (slide, i) {
        // Video slides don't zoom — a click there is for the player controls.
        if (slide.hasAttribute('data-media-video')) return;
        slide.style.cursor = 'zoom-in';
        slide.addEventListener('click', function () { open(i); });
      });
    }

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-close]')) { close(); return; }
      if (e.target.closest('[data-lightbox-prev]')) { goTo(Math.max(0, index() - 1), true); return; }
      if (e.target.closest('[data-lightbox-next]')) { goTo(Math.min(slides.length - 1, index() + 1), true); return; }
      if (!e.target.closest('[data-lb-slide] img, [data-lb-slide] video, .lightbox__watch')) { close(); }
    });
    // rAF-guard the counter sync so scrolling doesn't force layout per event.
    var counterRaf;
    track.addEventListener('scroll', function () {
      if (counterRaf) return;
      counterRaf = requestAnimationFrame(function () {
        counterRaf = null;
        setCounter(index());
      });
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') goTo(Math.min(slides.length - 1, index() + 1), true);
      else if (e.key === 'ArrowLeft') goTo(Math.max(0, index() - 1), true);
    });

    // Click-to-zoom toward the click point; click again to reset.
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        if (img.classList.contains('is-zoomed')) { resetZoom(); return; }
        resetZoom();
        var rect = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - rect.left) / rect.width * 100) + '% ' + ((e.clientY - rect.top) / rect.height * 100) + '%';
        img.classList.add('is-zoomed'); zoomed = img;
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.qbound) return;
      wrap.dataset.qbound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Mobile sticky add-to-cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-add-to-cart]');
    if (!bar || !anchor) return;
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { anchor.click(); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var offscreen = !entry.isIntersecting;
        bar.classList.toggle('is-visible', offscreen);
        bar.setAttribute('aria-hidden', offscreen ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Swipeable gallery (scroll-snap + thumbs + dots) ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      var viewport = gal.querySelector('[data-gallery-viewport]');
      if (!viewport) return;
      var slides = viewport.querySelectorAll('[data-slide]');
      var thumbs = gal.querySelectorAll('[data-thumb]');
      var dots = gal.querySelectorAll('[data-gallery-dots] .dot');

      function goTo(index) {
        viewport.scrollTo({ left: index * viewport.clientWidth, behavior: 'smooth' });
      }
      // Swiping away from a video slide stops it: hosted players pause,
      // click-to-load embeds unload back to their poster.
      function stopMedia(activeIndex) {
        slides.forEach(function (s, i) {
          if (i === activeIndex) return;
          s.querySelectorAll('video').forEach(function (v) { v.pause(); });
          var frame = s.querySelector('iframe.media-embed');
          if (frame) {
            frame.remove();
            var btn = s.querySelector('[data-video-load]');
            if (btn) btn.hidden = false;
          }
        });
      }
      function setActive(index) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        stopMedia(index);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-index'), 10) || 0;
          goTo(i); setActive(i);
        });
      });
      // Keep active thumb/dot synced to the swipe position.
      var raf;
      viewport.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          setActive(Math.round(viewport.scrollLeft / viewport.clientWidth));
        });
      });
      // Let variant switching (and initial variant) jump to a specific media.
      gal._goToMedia = function (mediaId) {
        var target = viewport.querySelector('[data-media-id="' + mediaId + '"]');
        if (!target) return;
        var index = Array.prototype.indexOf.call(slides, target);
        if (index > -1) { goTo(index); setActive(index); }
      };
      var initial = gal.getAttribute('data-initial-media');
      if (initial) { requestAnimationFrame(function () { gal._goToMedia(initial); }); }
    });
  }

  /* ---------- Login drawer (logged-out header account icon) ---------- */
  function initLoginDrawer() {
    var drawer = document.querySelector('[data-login-drawer]');
    if (!drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('input[type="email"]');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', '');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showView(which) {
      var login = drawer.querySelector('[data-login-view]');
      var recover = drawer.querySelector('[data-recover-view]');
      if (!login || !recover) return;
      login.hidden = which === 'recover';
      recover.hidden = which !== 'recover';
      var field = (which === 'recover' ? recover : login).querySelector('input[type="email"]');
      if (field) field.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-login-toggle]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-login-close]')) { e.preventDefault(); close(); return; }
      var show = e.target.closest('[data-login-show]');
      if (show && drawer.contains(show)) showView(show.getAttribute('data-login-show'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Contact form prefill (?product= from the PDP ask-me link) ---------- */
  function initContactPrefill() {
    var body = document.querySelector('[data-contact-body]');
    if (!body || body.value.trim() !== '') return;
    var product = new URLSearchParams(location.search).get('product');
    if (!product) return;
    var template = body.getAttribute('data-prefill-template') || 'I have a question about: [product]';
    body.value = template.replace('[product]', product) + '\n\n';
  }

  /* ---------- "Pairs well with" bundle (complementary recommendations) ---------- */
  function initComplementary() {
    var slot = document.querySelector('[data-complementary]');
    if (!slot || slot.dataset.fbtBound) return;
    slot.dataset.fbtBound = '1';
    fetch(slot.getAttribute('data-url'), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fbt = tmp.querySelector('[data-fbt]');
        if (!fbt) { slot.remove(); return; }
        slot.appendChild(fbt);

        var totalEl = fbt.querySelector('[data-fbt-total]');
        function rows() {
          return Array.prototype.map.call(fbt.querySelectorAll('[data-fbt-item]'), function (chk) {
            var select = chk.closest('.fbt__item').querySelector('[data-fbt-variant]');
            var opt = select && select.options[select.selectedIndex];
            return {
              checked: chk.checked,
              id: opt ? opt.value : chk.getAttribute('data-variant-id'),
              price: parseInt((opt || chk).getAttribute('data-price'), 10) || 0
            };
          });
        }
        var labelEl = fbt.querySelector('.fbt__total-label');
        var hintEl = fbt.querySelector('[data-fbt-hint]');
        function updateTotal() {
          var sum = rows().reduce(function (acc, r) { return r.checked ? acc + r.price : acc; }, 0);
          if (totalEl) totalEl.textContent = formatMoney(sum);
          if (labelEl) labelEl.hidden = sum === 0;
          if (hintEl) hintEl.hidden = sum > 0;
          var addBtn = fbt.querySelector('[data-fbt-add]');
          if (addBtn && !addBtn.dataset.busy) addBtn.disabled = sum === 0;
        }
        fbt.addEventListener('change', updateTotal);
        updateTotal();

        var addBtn = fbt.querySelector('[data-fbt-add]');
        if (addBtn) addBtn.addEventListener('click', function () {
          var items = rows().filter(function (r) { return r.checked; })
            .map(function (r) { return { id: parseInt(r.id, 10), quantity: 1 }; });
          if (!items.length) return;
          addBtn.dataset.busy = '1';
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelAdding || 'Adding…';
          var payload = { items: items };
          if (cartDrawerEnabled) payload.sections = 'cart-drawer';
          fetch(routeUrl('/cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.d.description || 'error');
              if (cartDrawerEnabled && res.d.sections && window.__renderCartDrawer) window.__renderCartDrawer(res.d.sections['cart-drawer']);
              refreshCartCount();
              addBtn.textContent = addBtn.dataset.labelAdded || 'Added to cart';
              afterAddToCart();
              setTimeout(function () { delete addBtn.dataset.busy; addBtn.disabled = false; addBtn.textContent = addBtn.dataset.labelDefault || 'Add selected to cart'; }, 1600);
            })
            .catch(function () {
              delete addBtn.dataset.busy;
              addBtn.disabled = false;
              addBtn.textContent = addBtn.dataset.labelDefault || 'Add selected to cart';
            });
        });
      })
      .catch(function () { slot.remove(); });
  }

  /* ---------- Discount codes in the cart drawer ---------- */
  function initCartDiscount() {
    // Delegated: the drawer body is replaced on every cart re-render.
    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('[data-discount-apply]');
      var removeBtn = e.target.closest('[data-discount-remove]');
      if (!applyBtn && !removeBtn) return;
      var box = e.target.closest('[data-discount-box]');
      if (!box) return;
      var codes = (box.getAttribute('data-codes') || '').split(',').filter(Boolean);
      var newCode = '';
      var msgInvalid = '';
      if (applyBtn) {
        var input = box.querySelector('[data-discount-input]');
        newCode = ((input && input.value) || '').trim();
        if (!newCode) return;
        var exists = codes.some(function (c) { return c.toLowerCase() === newCode.toLowerCase(); });
        if (!exists) codes.push(newCode);
        msgInvalid = applyBtn.dataset.msgInvalid || 'That code didn’t work.';
        applyBtn.disabled = true;
        applyBtn.textContent = applyBtn.dataset.labelChecking || '…';
      } else {
        var drop = removeBtn.getAttribute('data-code');
        codes = codes.filter(function (c) { return c !== drop; });
        removeBtn.disabled = true;
      }
      fetch(routeUrl('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data && data.sections && window.__renderCartDrawer) window.__renderCartDrawer(data.sections['cart-drawer']);
        refreshCartCount();
        if (!newCode) return;
        // If Shopify silently dropped the code, the fresh render won't list it — say so.
        var freshBox = document.querySelector('[data-discount-box]');
        if (!freshBox) return;
        var kept = (freshBox.getAttribute('data-codes') || '').split(',').some(function (c) {
          return c.toLowerCase() === newCode.toLowerCase();
        });
        if (!kept) {
          freshBox.setAttribute('open', '');
          var msg = freshBox.querySelector('[data-discount-msg]');
          if (msg) { msg.textContent = msgInvalid; msg.hidden = false; }
          var freshInput = freshBox.querySelector('[data-discount-input]');
          if (freshInput) freshInput.value = newCode;
        }
      }).catch(function () {
        var btn = document.querySelector('[data-discount-apply]');
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.labelDefault || 'Apply'; }
      });
    });
    // Enter in the code field applies instead of submitting anything.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-discount-input]');
      if (!input) return;
      e.preventDefault();
      var box = input.closest('[data-discount-box]');
      var btn = box && box.querySelector('[data-discount-apply]');
      if (btn) btn.click();
    });
  }

  /* ---------- External product videos (click-to-load, like the workshop map) ---------- */
  function initMediaVideos() {
    document.querySelectorAll('[data-video-load]').forEach(function (btn) {
      if (btn.dataset.vbound) return;
      btn.dataset.vbound = '1';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var slide = btn.closest('[data-slide]');
        if (!slide) return;
        var host = btn.getAttribute('data-video-host');
        var id = btn.getAttribute('data-video-id');
        var src = '';
        if (host === 'youtube') src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1';
        else if (host === 'vimeo') src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&dnt=1';
        if (!src) return;
        var frame = document.createElement('iframe');
        frame.src = src;
        frame.className = 'media-embed';
        frame.title = btn.getAttribute('data-video-title') || '';
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        slide.appendChild(frame);
        btn.hidden = true;
      });
    });
  }

  /* ---------- Close [data-close-outside] dropdowns on outside click / Escape ---------- */
  function initDetailsOutsideClose() {
    function closeAll(except) {
      document.querySelectorAll('details[data-close-outside][open]').forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (e) {
      var within = e.target.closest('details[data-close-outside]');
      // A click that lands on the details element itself is its ::before backdrop (mobile sheet) — close it.
      if (within && e.target === within) { within.removeAttribute('open'); return; }
      closeAll(within);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- Country selector search filter ---------- */
  function initLocaleSearch() {
    document.querySelectorAll('[data-locale-filter]').forEach(function (input) {
      var panel = input.closest('[data-locale-panel]');
      if (!panel) return;
      var items = panel.querySelectorAll('[data-locale-name]');
      var empty = panel.querySelector('[data-locale-empty]');
      function apply() {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        items.forEach(function (li) {
          var match = !q || li.getAttribute('data-locale-name').indexOf(q) !== -1;
          li.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      }
      input.addEventListener('input', apply);
      // The field lives inside the localization <form>; don't let Enter submit it.
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      // Focus on open, reset on close, so the list is whole again next time.
      var details = input.closest('details');
      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) { input.focus(); } else { input.value = ''; apply(); }
        });
      }
    });
  }

  /* ---------- Ajax collection filtering + load more ---------- */
  function initCollectionAjax() {
    var root = document.querySelector('[data-collection-root]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');

    function swap(url, mode) {
      root.setAttribute('aria-busy', 'true');
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString(), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var next = tmp.querySelector('[data-collection-root]');
          if (!next) { location.href = url; return; }
          if (mode === 'append') {
            var grid = root.querySelector('[data-collection-grid]');
            var newGrid = next.querySelector('[data-collection-grid]');
            if (grid && newGrid) {
              var i = 0;
              while (newGrid.firstElementChild) {
                var card = newGrid.firstElementChild;
                card.classList.add('is-new');
                card.style.setProperty('--i', Math.min(i++, 5));
                grid.appendChild(card);
              }
            }
            var oldMore = root.querySelector('[data-load-more-wrap]');
            var newMore = next.querySelector('[data-load-more-wrap]');
            if (oldMore) { if (newMore) oldMore.replaceWith(newMore); else oldMore.remove(); }
          } else {
            root.innerHTML = next.innerHTML;
            root.classList.add('is-fresh');
            setTimeout(function () { root.classList.remove('is-fresh'); }, 650);
          }
          root.removeAttribute('aria-busy');
          refreshWishUI(); initCardSwatches();
        })
        .catch(function () { location.href = url; }); // graceful fallback: full navigation
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-collection-filters]');
      if (!form || !root.contains(form)) return;
      e.preventDefault();
      var raw = new URLSearchParams(new FormData(form));
      var params = new URLSearchParams();
      raw.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var q = params.toString();
      var url = location.pathname + (q ? '?' + q : '');
      history.pushState({ collection: true }, '', url);
      swap(url, 'replace');
    });

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.filter-chip, .filters__clear');
      if (chip && root.contains(chip)) {
        e.preventDefault();
        var href = chip.getAttribute('href');
        history.pushState({ collection: true }, '', href);
        swap(href, 'replace');
        return;
      }
      var more = e.target.closest('[data-load-more]');
      if (more && root.contains(more)) {
        e.preventDefault();
        more.disabled = true;
        more.textContent = more.dataset.labelLoading || more.textContent;
        swap(more.getAttribute('data-url'), 'append');
      }
    });

    window.addEventListener('popstate', function () { swap(location.href, 'replace'); });
  }

  /* ---------- Product info tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      if (tabs.dataset.tbound) return;
      tabs.dataset.tbound = '1';
      var btns = tabs.querySelectorAll('[role="tab"]');
      var panels = tabs.querySelectorAll('[role="tabpanel"]');
      function select(i) {
        btns.forEach(function (b, j) {
          var on = i === j;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          if (panels[j]) panels[j].hidden = !on;
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + btns.length) % btns.length;
          select(n); btns[n].focus();
        });
      });
      select(0);
    });
  }

  /* ---------- Estimated delivery date ---------- */
  function initDeliveryEstimate() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      if (el.dataset.dbound) return;
      el.dataset.dbound = '1';
      function addBusinessDays(from, days) {
        var d = new Date(from);
        while (days > 0) {
          d.setDate(d.getDate() + 1);
          var w = d.getDay();
          if (w !== 0 && w !== 6) days--;
        }
        return d;
      }
      var now = new Date();
      var from = addBusinessDays(now, parseInt(el.dataset.minDays, 10) || 2);
      var to = addBusinessDays(now, parseInt(el.dataset.maxDays, 10) || 7);
      var fmt;
      try { fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'short' }); }
      catch (e) { return; }
      var span = el.querySelector('[data-delivery-text]');
      if (span) {
        span.textContent = (el.dataset.label || 'Estimated delivery:') + ' ' + fmt.format(from) + ' – ' + fmt.format(to);
        el.hidden = false;
      }
    });
  }

  /* ---------- Countdown banner ---------- */
  function initCountdown() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    els.forEach(function (el) {
      var end = new Date(el.dataset.end).getTime();
      if (isNaN(end)) return;
      var out = {
        d: el.querySelector('[data-cd-days]'),
        h: el.querySelector('[data-cd-hours]'),
        m: el.querySelector('[data-cd-mins]'),
        s: el.querySelector('[data-cd-secs]')
      };
      var expiredMsg = el.querySelector('[data-cd-expired]');
      var timer = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (timer) clearInterval(timer);
          if (el.dataset.hideExpired === 'true') {
            var sec = el.closest('.shopify-section') || el.closest('section') || el;
            sec.style.display = 'none';
            return;
          }
          diff = 0;
          el.classList.add('is-expired');
          if (expiredMsg) expiredMsg.hidden = false;
        }
        var secs = Math.floor(diff / 1000);
        if (out.d) out.d.textContent = pad(Math.floor(secs / 86400));
        if (out.h) out.h.textContent = pad(Math.floor(secs % 86400 / 3600));
        if (out.m) out.m.textContent = pad(Math.floor(secs % 3600 / 60));
        if (out.s) out.s.textContent = pad(secs % 60);
      }
      tick();
      if (end > Date.now()) timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Animated stat counters ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function finish(el, target) { el.textContent = target.toLocaleString(); }
    function animate(el) {
      var target = parseInt(el.dataset.target, 10) || 0;
      if (reduce || target <= 0) { finish(el, target); return; }
      var dur = 1400, start = null;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { finish(el, parseInt(el.dataset.target, 10) || 0); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Before / after image slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(function (el) {
      var range = el.querySelector('.ba__range');
      if (!range) return;
      range.addEventListener('input', function () {
        el.style.setProperty('--ba-pos', range.value + '%');
      });
    });
  }

  /* ---------- Shop-the-look hotspots ---------- */
  function initHotspots() {
    if (!document.querySelector('[data-hotspots]')) return;
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-hotspot-toggle]');
      if (toggle) {
        var spot = toggle.closest('.stl__spot');
        var open = spot.classList.contains('is-open');
        document.querySelectorAll('.stl__spot.is-open').forEach(function (s) {
          s.classList.remove('is-open');
          var b = s.querySelector('[data-hotspot-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          spot.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!e.target.closest('.stl__spot')) {
        document.querySelectorAll('.stl__spot.is-open').forEach(function (s) {
          s.classList.remove('is-open');
          var b = s.querySelector('[data-hotspot-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.stl__spot.is-open').forEach(function (s) {
        s.classList.remove('is-open');
        var b = s.querySelector('[data-hotspot-toggle]');
        if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (el) {
      var track = el.querySelector('[data-slideshow-track]');
      var slides = el.querySelectorAll('[data-slideshow-slide]');
      if (!track || slides.length < 2) return;
      var dots = el.querySelectorAll('[data-slideshow-dot]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = !reduce && parseInt(el.dataset.autoplay, 10) > 0;
      var delay = (parseInt(el.dataset.autoplay, 10) || 6) * 1000;
      var timer = null;

      function index() { return Math.round(track.scrollLeft / track.clientWidth); }
      function goTo(i) {
        var n = slides.length;
        i = ((i % n) + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      function syncDots() {
        var i = index();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!autoplay || timer) return;
        timer = setInterval(function () { goTo(index() + 1); }, delay);
      }

      el.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-slideshow-dot]');
        if (dot) { stop(); goTo(parseInt(dot.dataset.slideshowDot, 10)); return; }
        if (e.target.closest('[data-slideshow-prev]')) { stop(); goTo(index() - 1); return; }
        if (e.target.closest('[data-slideshow-next]')) { stop(); goTo(index() + 1); }
      });
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncDots, 80);
      });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      el.addEventListener('focusin', stop);
      track.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      start();
    });
  }

  /* ---------- Padel keychain builder ---------- */
  function initKeychainBuilder() {
    document.querySelectorAll('[data-keychain-builder]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var nameInput = root.querySelector('[data-kc-name]');
      var svgBody = root.querySelector('[data-kc-svg-body]');
      var svgName = root.querySelector('[data-kc-svg-name]');
      var view = root.querySelector('[data-kc-canvas]');
      var three = null;
      var state = { name: '', body: null, text: null };

      function applyColor(kind, input) {
        state[kind] = { label: input.value, hex: input.getAttribute('data-kc-hex') || '#ccc' };
        var lab = root.querySelector('[data-kc-label="' + kind + '"]');
        if (lab) lab.textContent = state[kind].label;
        if (kind === 'body') {
          if (svgBody) svgBody.setAttribute('fill', state.body.hex);
          if (three) three.setBodyColor(state.body.hex);
        } else {
          // second picker = hitting-area colour; the flat SVG stand-in has no
          // face layer, so only the 3D scene reacts (the name shares the body colour)
          if (three) three.setTextColor(state.text.hex);
        }
        syncClashes();
      }

      // Racket and hitting area in the same colour would make the inlaid name
      // invisible (on the print too): in each group, strike out the swatch
      // matching the other group's pick. Selections start out different, so
      // no collision state is reachable.
      function syncClashes() {
        ['body', 'text'].forEach(function (kind) {
          var other = state[kind === 'body' ? 'text' : 'body'];
          var grp = root.querySelector('[data-kc-swatches="' + kind + '"]');
          if (!grp || !other) return;
          var inputs = grp.querySelectorAll('input[type="radio"]');
          if (inputs.length < 2) return; // single colour: nothing to steer
          inputs.forEach(function (inp) {
            var clash = inp.value === other.label;
            inp.disabled = clash;
            var sw = inp.closest('.swatch');
            if (sw) sw.classList.toggle('is-unavailable', clash);
          });
        });
      }
      root.querySelectorAll('[data-kc-swatches]').forEach(function (grp) {
        var kind = grp.getAttribute('data-kc-swatches');
        grp.addEventListener('change', function (e) {
          if (e.target.matches('input[type="radio"]')) applyColor(kind, e.target);
        });
        var checked = grp.querySelector('input:checked');
        if (checked) applyColor(kind, checked);
      });

      var nameTimer;
      function applyName() {
        state.name = nameInput.value.trim();
        if (svgName) {
          var len = state.name.length || 1;
          svgName.setAttribute('font-size', Math.min(26, 132 / (0.62 * len)));
          svgName.textContent = state.name.toUpperCase();
        }
        if (three) three.setName(state.name);
      }
      if (nameInput) {
        nameInput.addEventListener('input', function () {
          clearTimeout(nameTimer);
          nameTimer = setTimeout(applyName, 120);
          var err = root.querySelector('[data-form-error]');
          if (err && !err.hidden) err.hidden = true;
        });
        // the pre-filled example name should vanish on first interaction
        nameInput.addEventListener('focus', function () {
          var self = this;
          requestAnimationFrame(function () { self.select(); });
        });
        applyName();
      }

      // Don't let the pre-filled example name reach the cart: intercept the
      // add button (implicit form submission clicks it too) while the field
      // still equals its pre-fill.
      var kcAtc = root.querySelector('[data-add-to-cart]');
      if (kcAtc && nameInput && nameInput.getAttribute('data-kc-default')) {
        kcAtc.addEventListener('click', function (e) {
          var def = nameInput.getAttribute('data-kc-default').trim().toLowerCase();
          if (nameInput.value.trim().toLowerCase() !== def) return;
          e.preventDefault();
          e.stopPropagation();
          var err = root.querySelector('[data-form-error]');
          if (err) {
            err.textContent = nameInput.getAttribute('data-kc-default-error') || 'Type the name you want printed first';
            err.hidden = false;
          }
          nameInput.focus();
        });
      }

      // 3D preview: load Three.js lazily; the SVG stand-in stays if this fails.
      // Loaded through an injected inline module script instead of a direct
      // dynamic import(): Shopify's CDN minifier treats this file as CommonJS
      // and rewrites syntactic import() into require(), which crashes in the
      // browser. Inline module scripts never pass through the minifier.
      function importModule(url) {
        return new Promise(function (resolve, reject) {
          var key = '__kcImport' + Math.random().toString(36).slice(2);
          window[key] = { resolve: resolve, reject: reject };
          var s = document.createElement('script');
          s.type = 'module';
          s.textContent = 'var h = window[' + JSON.stringify(key) + ']; delete window[' + JSON.stringify(key) + ']; import(' + JSON.stringify(url) + ').then(h.resolve, h.reject);';
          document.head.appendChild(s);
          setTimeout(function () { s.remove(); }, 0);
        });
      }
      if (view && root.dataset.moduleUrl && window.WebGLRenderingContext) {
        importModule(root.dataset.moduleUrl).then(function (mod) {
          three = mod.mount(view);
          if (state.body) three.setBodyColor(state.body.hex);
          if (state.text) three.setTextColor(state.text.hex);
          three.setName(state.name);
          var fb = root.querySelector('[data-kc-fallback]');
          if (fb) fb.remove();
          var hint = root.querySelector('[data-kc-hint]');
          if (hint) hint.hidden = false;
        }).catch(function (err) {
          // SVG stand-in stays; log why so field reports aren't blind.
          if (window.console && console.warn) console.warn('[keychain-3d] preview failed to mount:', err);
        });
      }
    });
  }
  document.addEventListener('shopify:section:load', function () {
    initKeychainBuilder(); initPartsKitBuilder(); initProductForm(); initQty(); initPopup();
  });

  /* ---------- Parts kit builder (generic: one product, choices as line item properties) ---------- */
  function initPartsKitBuilder() {
    document.querySelectorAll('[data-parts-kit]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var form = root.querySelector('form');
      if (!form) return;
      var summary = root.querySelector('[data-kit-summary]');
      var summaryWrap = root.querySelector('[data-kit-summary-wrap]');
      var summaryLabel = root.querySelector('[data-kit-summary-label]');
      var submit = root.querySelector('[data-add-to-cart]');
      var err = root.querySelector('[data-form-error]');
      var soldOut = submit && submit.hasAttribute('data-sold-out');
      var idField = form.querySelector('input[name="id"]');

      // Kits with real variants (e.g. Material: ABS / PC-PBT-GF): the pill
      // swaps the variant id and the price, and a single-colour variant hides
      // and disables the colour fields so they never reach the order.
      function applyVariant(updateUrl) {
        var picked = root.querySelector('[data-kit-variant]:checked');
        if (!picked) return;
        if (idField) idField.value = picked.value;
        root.querySelectorAll('[data-kit-price]').forEach(function (p) {
          p.hidden = p.getAttribute('data-kit-price') !== picked.value;
        });
        var single = picked.hasAttribute('data-kit-single-colour');
        root.querySelectorAll('[data-kit-colour]').forEach(function (g) {
          g.hidden = single;
          g.querySelectorAll('input').forEach(function (i) { i.disabled = single; });
        });
        if (updateUrl) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', picked.value);
            window.history.replaceState(window.history.state, '', u.toString());
          } catch (e) { /* old browser: URL just doesn't follow */ }
        }
      }

      // Reads every field group back into one line the customer can check
      // before paying, and returns how many required fields are still empty.
      function render() {
        var parts = [];
        var missing = 0;
        var missingLabels = [];
        root.querySelectorAll('[data-kit-group]').forEach(function (group) {
          if (group.hidden) return;
          var label = group.getAttribute('data-kit-group') || '';
          var val = '';
          var sel = group.querySelector('select[data-kit-field]');
          if (sel) val = sel.value;
          var radio = group.querySelector('input[type="radio"][data-kit-field]:checked');
          if (radio) val = radio.value;
          var txt = group.querySelector('input[type="text"][data-kit-field]');
          if (txt) val = txt.value.trim();
          if (!val) {
            if (group.hasAttribute('data-kit-required')) { missing++; missingLabels.push(label); }
            return;
          }
          parts.push(label + ': ' + val);
        });
        // Incomplete: the quiet confirmation line turns into "Still to choose: …"
        // so the disabled button never leaves the customer guessing why.
        if (summary) summary.textContent = missing > 0 ? missingLabels.join(' · ') : parts.join(' · ');
        if (summaryLabel && summaryWrap) {
          summaryLabel.textContent = summaryWrap.getAttribute(missing > 0 ? 'data-label-missing' : 'data-label-summary') || '';
        }
        if (summaryWrap) {
          summaryWrap.hidden = parts.length === 0 && missing === 0;
          summaryWrap.classList.toggle('kit-summary--incomplete', missing > 0);
        }
        if (submit && !soldOut) submit.disabled = missing > 0;
        if (err && missing === 0) err.hidden = true;
        return missing;
      }

      form.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-kit-variant')) applyVariant(true);
        render();
      });
      form.addEventListener('input', render);

      // Capture phase on purpose: this has to run before the theme's own AJAX
      // add-to-cart handler, or an incomplete configuration reaches the cart.
      form.addEventListener('submit', function (e) {
        if (render() > 0) {
          e.preventDefault();
          e.stopPropagation();
          if (err) {
            err.textContent = err.getAttribute('data-msg') || '';
            err.hidden = false;
          }
          var first = root.querySelector('[data-kit-required] select[data-kit-field], [data-kit-required] input[type="text"][data-kit-field]');
          if (first) first.focus();
        }
      }, true);

      applyVariant(false);
      render();
    });
  }

  /* ---------- Popup (newsletter / promo) ---------- */
  function initPopup() {
    var pop = document.querySelector('[data-popup]');
    if (!pop || pop.dataset.bound) return;
    pop.dataset.bound = '1';
    var KEY = 'pjotr-popup-snooze';
    var snoozeDays = parseInt(pop.dataset.snoozeDays, 10) || 7;

    function snoozedUntil() {
      try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; }
    }
    function snooze(days) {
      try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) { /* private mode */ }
    }
    function open() {
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var closeBtn = pop.querySelector('.popup__close');
      if (closeBtn) closeBtn.focus();
      snooze(snoozeDays); // shown once counts — don't re-open on every page view
    }
    function close() {
      pop.classList.remove('is-open');
      pop.hidden = true;
      snooze(snoozeDays);
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) close();
      if (e.target.closest('[data-popup-cta]')) snooze(snoozeDays); // navigating away counts as seen
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) close();
    });

    if (pop.hasAttribute('data-design-mode')) {
      // Theme editor: only open while the merchant has the section selected.
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(pop)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(pop)) { pop.classList.remove('is-open'); pop.hidden = true; }
      });
      return;
    }

    if (/[?&]customer_posted=true/.test(location.search) && pop.querySelector('[data-popup-success]')) {
      open();               // came back from the newsletter form: show the thank-you + code
      snooze(365);          // subscribed — don't nag again
      return;
    }
    if (Date.now() < snoozedUntil()) return;
    // Exit intent: open when the cursor leaves toward the browser bar.
    // Pointer-only — touch devices can't exit-intent, so they fall through
    // to the delay trigger below. Stays armed while the cookie banner is up.
    if (pop.dataset.trigger === 'exit' && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var armed = true;
      document.addEventListener('mouseout', function (e) {
        if (!armed || e.relatedTarget || e.clientY > 0) return;
        var banner = document.querySelector('[data-cookie-banner]');
        if (banner && !banner.hidden) return;
        armed = false;
        open();
      });
      return;
    }
    // Wait out the cookie banner: two dialogs at once is too pushy. The banner
    // shows on a short delay of its own, so re-check right before opening too.
    (function schedule() {
      var banner = document.querySelector('[data-cookie-banner]');
      if (banner && !banner.hidden) { setTimeout(schedule, 2500); return; }
      setTimeout(function () {
        var b = document.querySelector('[data-cookie-banner]');
        if (b && !b.hidden) { schedule(); return; }
        open();
      }, (parseInt(pop.dataset.delay, 10) || 8) * 1000);
    })();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var disabled = document.body.getAttribute('data-reveal-enabled') === 'false';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (disabled || reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCookieBanner();
    initBackToTop();
    initAnnouncement();
    initHeaderShadow();
    initMobileMenu();
    initNavDropdowns();
    initFaviconCount();
    initCartDrawer();
    initPredictiveSearch();
    initCardSwatches();
    initWishlist();
    initRecentlyViewed();
    initQuickView();
    initQuickAdd();
    initProductForm();
    initVariants();
    initQty();
    initGallery();
    initLightbox();
    initMediaVideos();
    initCartDiscount();
    initComplementary();
    initContactPrefill();
    initLoginDrawer();
    initProductRecommendations();
    initStickyAtc();
    initDetailsOutsideClose();
    initLocaleSearch();
    initCollectionAjax();
    initTabs();
    initDeliveryEstimate();
    initCountdown();
    initCounters();
    initBeforeAfter();
    initHotspots();
    initSlideshow();
    initKeychainBuilder();
    initPartsKitBuilder();
    initPopup();
    initReveal();
    // Cart count is rendered server-side; only refresh after an AJAX add (no fetch on every page load).
  });
})();
